import { Grid, useMediaQuery, useTheme } from '@mui/material';
import ToolsAndTechnologiesCard from './tools-and-technology-card';
import { IPermissions, TabInfo } from '../../common/utils/interfaces';
import { Tool } from '../type';

interface PropsType {
  toolsAndTechnologies: Tool[];
  editToolCallback: (toolId: string) => void;
  searchedTool: string;
  tabs: TabInfo[];
  selectedTab: string;
  permissions: IPermissions;
}

const ToolsAndTechnologiesGrid = ({
  editToolCallback,
  toolsAndTechnologies,
  searchedTool,
  tabs,
  selectedTab,
  permissions
}: PropsType): JSX.Element => {
  const theme = useTheme();
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const isSmallScreen = useMediaQuery(theme.breakpoints.up('md'));
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.up('sm'));

  const columns = isExtraLargeScreen
    ? 4
    : isMediumScreen
    ? 3
    : isSmallScreen
    ? 2
    : isExtraSmallScreen
    ? 1
    : 1;

  let filteredTools: Tool[];

  if (searchedTool) {
    filteredTools = toolsAndTechnologies.filter((tool) =>
      tool.name.toLocaleLowerCase().startsWith(searchedTool.toLocaleLowerCase())
    );
  } else {
    filteredTools = toolsAndTechnologies;
  }

  if (selectedTab) {
    filteredTools = filteredTools.filter(
      (tool) => tool.department === selectedTab
    );
  }

  filteredTools.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Grid marginRight={1} container spacing={4}>
      {[...Array(columns)].map((_value, colIndex) => (
        <Grid key={colIndex} item xs={12} sm={12} md={6} lg={4} xl={3}>
          {filteredTools
            .filter((_, index) => index % columns === colIndex)
            .map((toolAndTechnology) => (
              <Grid marginBottom={2} key={toolAndTechnology.name} item xs={12}>
                <ToolsAndTechnologiesCard
                  tool={toolAndTechnology}
                  editToolCallback={editToolCallback}
                  tabs={tabs}
                  permissions={permissions}
                />
              </Grid>
            ))}
        </Grid>
      ))}
    </Grid>
  );
};

export default ToolsAndTechnologiesGrid;
